/* ZWARTWIT SLIDER -------------------------------------------------------------------------------------------------- */

(function($){
    $.fn.extend({
        zwitSlider: function(options) {

            var defaults = {
                slides: '',
				showButtons: false,
				showItems: false,
				itemsBefore: false,
				btnNext: '',
				btnPrev: '',
				easing: "Sine.easeInOut",
				activeSlide: 0,
				autoHeight: false,
				autoPlay: false
            };

			

			var obj;
			var options = $.extend(defaults, options);

			var touchSupported = Modernizr.touch;
			var touchOrClick = Modernizr.touch ? 'touchstart' : 'click';
			
			var allSlides = options.slides;
			var btnNext = options.btnNext;
			var btnPrev = options.btnPrev;
			var easing = options.easing;
			var currentSlide = options.activeSlide;



			function init()
			{
				TweenLite.set(allSlides, {autoAlpha:0}); // laat alleen de eerste zien
				TweenLite.set(allSlides.eq(options.activeSlide), {autoAlpha:1}); // laat alleen de eerste zien
				//TweenMax.set('#twitter .slides', {css:{transformPerspective:600, perspective:600, transformStyle:"preserve-3d"}}); // set perspective items

				if( options.showButtons )
					setButtons();

				if( options.showItems )
					slidesItems();

				if( !options.autoHeight )
					fixedHeight();
				else 
					autoHeight();

				if( options.autoPlay)
					autoPlay();
			}

			function fixedHeight() 
			{
				var height = 0;

				for (var i = allSlides.length - 1; i >= 0; i--) 
				{
					if( allSlides.eq(i).height() > height )
						height = allSlides.eq(i).height();
				}

				$('.slides', obj).height( height + 20 );
			}

			function autoHeight()
			{
				$('.slides', obj).height( allSlides.eq(options.activeSlide).height() + 30 );
			}

			function setButtons()
			{

				if (Modernizr.touch) {
					$(btnPrev).on('touchstart', function(e) { e.preventDefault(); }).on('touchend', function(e) { nextPrevSlide('prev'); });
					$(btnNext).on('touchstart', function(e) { e.preventDefault(); }).on('touchend', function(e) { nextPrevSlide('next'); });
				}
				else
				{
					$(btnPrev).bind(touchOrClick, function(e) {
						e.preventDefault();
						nextPrevSlide('prev');
					});
					$(btnNext).bind(touchOrClick, function(e) {
						e.preventDefault();
						nextPrevSlide('next');
						return false;
					});
				}

			}

			
			function setActiveItem( item )
			{
				$('.nav', obj).removeClass('active');
				$('.nav:eq('+item+')', obj).addClass('active');
			}


			function nextPrevSlide( value )
			{
				if( !$('.slides').hasClass('active') )
				{
					var currentFrom = "0%";
					var currentTo = "20%";
					var nextFrom = "-20%";
					var nextTo = "0%";

					if(value === 'next')
					{
						currentFrom = "0%";
						currentTo = "-20%";
						nextFrom = "20%";
						nextTo = "0%";
					}

					if( options.interval )
						clearInterval(options.interval);
					$('.slides').addClass('active');

					TweenMax.fromTo(
						allSlides.eq(currentSlide),
						0.3,
						{alpha:1, x:currentFrom},
						{delay:0, alpha:0, x:currentTo, ease:easing}
					);


					if( value === 'next') { currentSlide = ++currentSlide % allSlides.length; } //find out which is the next slide
					else { currentSlide = --currentSlide % allSlides.length; } //find out which is the next slide
					setActiveItem( currentSlide );
					
					if( options.autoHeight )
						$('.slides', obj).height( $(active).height() + 30 );					


					TweenMax.fromTo(
						allSlides.eq(currentSlide),
						0.3,
						{alpha:0, x:nextFrom},
						{delay:0.1, x:nextTo, autoAlpha:1, ease:easing, onComplete: function() 
							{ 
								$('.slides').removeClass('active');
								if( options.autoPlay)
								{
									//console.log('timeout --- '+obj.context.id);
									autoPlay();
								}
							} 
						}
					);
				}
			}


			function selectSlide( item )
			{
				if( item == currentSlide)
					return;

				if( !$('.slides').hasClass('active') )
				{
					var currentFrom = "0%";
					var currentTo = "20%";
					var nextFrom = "-20%";
					var nextTo = "0%";

					if(item > currentSlide)
					{
						currentFrom = "0%";
						currentTo = "-20%";
						nextFrom = "20%";
						nextTo = "0%";
					}

					if( options.interval )
						clearInterval( options.interval );
					$('.slides').addClass('active');

					TweenMax.fromTo(
						allSlides.eq(currentSlide),
						0.3,
						{alpha:1, x:currentFrom},
						{delay:0, alpha:0, x:currentTo, ease:easing}
					);

					currentSlide = item;
					setActiveItem( currentSlide );

					var active = allSlides.eq(currentSlide);
					
					if( options.autoHeight )
						$('.slides', obj).height( $(active).height() + 30 );					

					TweenMax.fromTo(
						allSlides.eq(currentSlide),
						0.3,
						{alpha:0, x:nextFrom},
						{delay:0.1, x:nextTo, autoAlpha:1, ease:easing, onComplete: function() 
							{ 
								$('.slides').removeClass('active');
								if( options.autoPlay )
								{
									autoPlay();
								}
							} 
						}
					);
				}
			}

			function autoPlay() 
			{
				options.interval = setInterval(function(){ nextPrevSlide('next'); }, options.autoPlay);
			}


			function slidesItems() 
			{

				if( options.itemsBefore )
					$(obj).prepend('<div class="slideItems" href="#"></div>');
				else 
					$(obj).append('<div class="slideItems" href="#"></div>');


				for (var i = allSlides.length - 1; i >= 0; i--)
				{
					if( options.activeSlide == i ) 
						$('.slideItems',obj).prepend('<a class="nav active" href="#"></a>');
					else
						$('.slideItems',obj).prepend('<a class="nav" href="#"></a>');
				}


				$('.nav',obj).click( function(e) {
					e.preventDefault();
					selectSlide( $(this).index() );
				});		
			}


			$( window ).resize(function() {
  
				if( !options.autoHeight )
					fixedHeight();
				else 
					autoHeight();

			});



            return this.each(function() {
	
				obj = $(this);
				init( );

			});

        }
    });
})(jQuery);


jQuery(document).ready(function($){

	var timeOutQuotes,
		timeOutSysteem;

	$('#ervaringen').zwitSlider({

        slides: $('#ervaringen .slides li'),
		showButtons: false,
		showItems: true,
		itemsBefore: false,
		btnNext: '#ervaringen .btn-next',
		btnPrev: '#ervaringen .btn-prev',
		easing: "Sine.easeInOut",
		activeSlide: 0,
		autoPlay: 7000
								
	});

});